export default __webpack_public_path__ + "static/media/speedtest-awards.e024bc1a.svg";